/** @format */
import { ModelListing } from '@toucan/client/global/model';

import { ElementBreakpointsStatus } from '@toucan/client/shared/hooks/use-element-breakpoints';

export type ModelCardProps = {
    modelListing?: ModelListing;
    'data-testid'?: string;
    className?: string;
    onCreateAlert?: (model: ModelListing) => void;
};

export enum ModelCardBreakpointsEnum {
    SMALL = 'small',
    MEDIUM = 'medium',
}

export const modelCardBreakpoints = {
    [ModelCardBreakpointsEnum.SMALL]: 500,
    [ModelCardBreakpointsEnum.MEDIUM]: 800,
};

export type ModelCardBreakpointsState = ElementBreakpointsStatus<
    typeof modelCardBreakpoints
>;

export type StyledModelCardProps = Pick<
    ModelCardProps,
    'data-testid' | 'className'
> & {
    modelCardBreakpointsState: ModelCardBreakpointsState;
    isOutOfStock: boolean;
};
